import { type ComponentProps, memo, type RefObject } from 'react';

import { Uploads } from '@air/next-icons';
import { cn } from '@air/utils-tailwind';

import { type DropZone } from '~/components/PrivateDropzone/types';

export type SingleZoneOverlayProps = ComponentProps<'div'> & {
  hoveredZone: DropZone | null;
  currentWorkspaceName?: string;
  dropZoneChooseBoardRef: RefObject<HTMLDivElement>;
};

export const SingleZoneOverlay = memo(
  ({ hoveredZone, currentWorkspaceName, dropZoneChooseBoardRef, className, ...rest }: SingleZoneOverlayProps) => (
    <div
      {...rest}
      ref={dropZoneChooseBoardRef}
      data-testid="SINGLE_ZONE_OVERLAY_CONTENT"
      className={cn(
        'absolute top-18 right-2 bottom-2 left-2 flex flex-col items-center justify-center rounded-12 bg-grey-1/80 px-4 py-8 text-grey-12 backdrop-blur-[17.5px]',
        hoveredZone === 'choose-board' ? 'outline outline-2 outline-blue-9' : 'outline-dashed outline-1 outline-grey-7',
        className,
      )}
    >
      <div className="flex flex-col items-center gap-2">
        <Uploads className="size-6" />
        <div className="flex flex-col items-center gap-1 text-center">
          <h2 className="font-medium text-16 text-grey-12">Drop files here to upload</h2>
          <p className="text-12 text-grey-10">
            Choose where to upload your files in {currentWorkspaceName ? currentWorkspaceName : 'this workspace'}
          </p>
        </div>
      </div>
    </div>
  ),
);

SingleZoneOverlay.displayName = 'SingleZoneOverlay';
